import React, { useEffect, useState } from 'react';
import { arrayMoveImmutable } from 'array-move';
import CategoryListSortable from '@/components/tecdocSettings/TecdocMenuCreate/CategoryList';
import { Alert, Breadcrumb, Button, message, Skeleton, Spin, Typography } from 'antd';
import CreateMainCategory from '@/components/tecdocSettings/TecdocMenuCreate/CreateMainCategory';
import api from '@/services/api';
import useFetchCategories from '@/hooks/adminTecdoc/useFetchCategories';
import useCreateCategory from '@/hooks/adminTecdoc/useCreateCategory';
import useChangeSort from '@/hooks/adminTecdoc/useChangeSort';
import { Link, useNavigate, useParams } from 'react-router-dom';
import DispatchGenericArticleToCategory from '@/components/tecdocSettings/TecdocMenuCreate/DispatchGenericArticleToCategory';
import useUpdateCategory from '@/hooks/adminTecdoc/useUpdateCategory';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';


// ✅ Tekil GenericArticleItem Bileşeni
const GenericArticleItem = ({ onClickEditHandler, onClickHandler, onDelete, hideEdit, item, loading }) => {

    const [loadingDelete, setLoadingDelete] = useState(false);

    const onClickDeleteHandler = (id) => {
        setLoadingDelete(true);
        api()({
            url: `webshop/management/tecdoc-menu-install/generic-articles/${id}`,
            method: 'DELETE'
        }).then(() => {
            message.success('Generic article deleted successfully');
            onDelete(id);
        }).catch(() => {
            message.error('Error deleting generic article');
        }).finally(() => {
            setLoadingDelete(false);
        });
    };

    return (
        <li style={{
            width: '100%',
            padding: '12px',
            marginBottom: '10px',
            borderRadius: '24px',
            listStyle: 'none',
            backgroundColor: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: `rgba(0, 0, 0, 0.05) 0px 0px 0px 1px`
        }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button style={{ marginLeft: '10px' }} onClick={() => onClickHandler(item)}>
                    {item?.label}
                </button>
            </div>
            <div>
                <Typography.Text style={{ marginRight: '15px', cursor: 'pointer' }}>
                    {`Generic Article ID : ` + item?.value}
                </Typography.Text>

                <Button
                    loading={loadingDelete}
                    style={{ marginRight: '10px' }}
                    type='default'
                    icon={<DeleteOutlined style={{ fontSize: '20px' }} />}
                    onClick={() => onClickDeleteHandler(item.id)}
                />

                {hideEdit === true && (
                    <Button
                        onClick={() => onClickEditHandler(item)}
                        type='primary'
                        icon={<EditOutlined style={{ fontSize: '20px', cursor: 'pointer' }} />}
                    />
                )}
            </div>
        </li>
    );
};

// ✅ Ana Sayfa Bileşeni
const AddTecdocCategories = () => {
    const { subcategoryId, categoryId } = useParams();
    const [category, setCategory] = useState({});
    const [subCategory, setSubcategory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [genericArticles, setGenericArticles] = useState([]);
    const [loadingDelete, setLoadingDelete] = useState({});

    const language = useSelector((e) => e.settings.Language)


    const up1 = useUpdateCategory();
    const up2 = useUpdateCategory();

    useEffect(() => {
        up1.fetch(subcategoryId, categoryId).then(e => {
            setCategory(e);
        });
    }, [subcategoryId, categoryId]);

    useEffect(() => {
        up2.fetch(categoryId).then(e => {
            setSubcategory(e);
        });
    }, [categoryId]);

    const fetchCategories = useFetchCategories(subcategoryId);
    const changeSort = useChangeSort();
    const navigate = useNavigate();

    const onSortEnd = ({ oldIndex, newIndex }) => {
        let newList = arrayMoveImmutable(fetchCategories.categories, oldIndex, newIndex);
        fetchCategories.setCategories(newList);
        let ids = newList.map((item, index) => [item?.id, index]);
        changeSort.changeSort(ids);
    };

    const [showCreateModal, setShowCreateModal] = useState(false);



    const onUpdateHandler = (e) => {
        fetchCategories.setCategories(prev => prev.map(f => f?.id === e?.id ? e : f));
    };

    const onCreateHandler = (e) => {
        fetchGenericArticles();
    };

    const onClickHandler = (item) => {
        navigate(`/management/catalog-tecdoc/brands/subcategory/${subcategoryId}/${item?.value}/`);
    };

    const fetchGenericArticles = async () => {
        setLoading(true);
        try {
            let list = await api()({
                url: `webshop/management/tecdoc-menu-install/generic-articles/find?selectedLanguage=${language?.toUpperCase()}&categoryId=${subcategoryId}`,
                method: 'GET'
            });
            setGenericArticles(list.data.data.filter(c => c.id));
        } catch (error) {
            message.error('Error fetching generic articles');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGenericArticles();
    }, [subcategoryId, language]);

    return (
        <Skeleton loading={loading}>
            <Alert message="These categories are provided by tecdoc" type="info" showIcon />
            <Alert message="You can create a new category and then assign generic articles to it." type="info" showIcon className='mt-2' />
            <br />
            <DispatchGenericArticleToCategory
                onCreate={onCreateHandler}
                categoryId={subcategoryId}
                show={showCreateModal}
                onCancel={() => setShowCreateModal(false)}
            />
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <div>
                    <Breadcrumb>
                        <Breadcrumb.Item><Link to={'/management/catalog-tecdoc'}>Categories</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to={`/management/catalog-tecdoc/${categoryId}`}>{subCategory?.categoryName}</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{category?.categoryName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div>
                    <Button onClick={() => setShowCreateModal(true)} type='primary'>New Category</Button>
                </div>
            </div>
            <br />
            <div>
                <ul style={{ paddingLeft: 0 }}>
                    {genericArticles.map(item => (
                        <GenericArticleItem
                            loading={loadingDelete[item.id] || false}
                            onDelete={(id) => { setGenericArticles(prev => prev.filter(g => g.id !== id)); }}
                            onClickEditHandler={() => { }}
                            onClickHandler={onClickHandler}
                            item={item}
                            hideEdit={true}
                        />
                    ))}
                </ul>
            </div>
        </Skeleton>
    );
};

export default AddTecdocCategories;
